

import OnDayProcess from "@/views/OnDayProcess.vue";
import {Component, Vue} from "vue-facing-decorator";

@Component({
  components: {
    Home: OnDayProcess
  }
})
export default class App extends Vue {

}

